<div class="admin-modal">
  <div class="modal-header">
    <h3 class="modal-title">What's a Cron Expression?</h3>
    <div class="header-actions">
      <i class="fa fa-times" style="cursor: pointer" (click)="close()"></i>
    </div>
  </div>
  <div class="modal-body">
    <p>
      A CRON expression is a string comprising five or six fields separated by white space that represents a set of times,
      normally as a schedule to execute some routine.
    </p>
    <table id="cron-explains-table">
      <thead>
        <tr>
          <th>Field</th>
          <th>Required</th>
          <th>Allowed values</th>
          <th>Allowed special characters</th>
          <th>Remarks</th>
        </tr>
      </thead>
      <tbody>
        <tr><td>Seconds</td><td>Yes</td><td>0-59</td><td><code>*</code> <code>,</code> <code>-</code></td><td></td></tr>
        <tr><td>Minutes</td><td>Yes</td><td>0-59</td><td><code>*</code> <code>,</code> <code>-</code></td><td></td></tr>
        <tr><td>Hours</td><td>Yes</td><td>0-23</td><td><code>*</code> <code>,</code> <code>-</code></td><td></td></tr>
        <tr><td>Day of month</td><td>Yes</td><td>1-31</td><td><code>*</code> <code>,</code> <code>-</code> <code>?</code> <code>L</code> <code>W</code></td><td></td></tr>
        <tr><td>Month</td><td>Yes</td><td>1-12 or JAN-DEC</td><td><code>*</code> <code>,</code> <code>-</code></td><td></td></tr>
        <tr><td>Day of week</td><td>Yes</td><td>0-6 or SUN-SAT</td><td><code>*</code> <code>,</code> <code>-</code> <code>?</code> <code>L</code> <code>#</code></td><td></td></tr>
        <tr><td>Year</td><td>No</td><td>1970-2099</td><td><code>*</code> <code>,</code> <code>-</code></td><td>Not supported in all implementations.</td></tr>
      </tbody>
    </table>
    <p>E.g., <code>0 0 12 ? DEC *</code> means <span class="bold">Every day at noon in December only</span>.</p>
  </div>
</div>
